(function () {
  if (window.TownWineFollow) {
    if (typeof window.TownWineFollow.init === 'function') {
      window.TownWineFollow.init(document);
    }
    return;
  }

  var DEFAULT_PROXY_BASE = '/apps/townwine-follow';
  var initialized = false;
  var loginStateByProxy = Object.create(null);

  function getCustomerContext() {
    var customer = window.TownWineCustomer || {};

    return {
      email: String(customer.email || '').trim(),
      firstName: String(customer.firstName || '').trim(),
    };
  }

  function appendCustomerParams(searchParams) {
    var customer = getCustomerContext();

    if (customer.email) {
      searchParams.set('customerEmail', customer.email);
    }

    if (customer.firstName) {
      searchParams.set('customerFirstName', customer.firstName);
    }

    return searchParams;
  }

  function normalizeHandle(value) {
    var handle = String(value || '').trim();

    if (!handle) return '';

    if (/^https?:\/\//i.test(handle)) {
      try {
        var url = new URL(handle);
        var segments = url.pathname.split('/').filter(Boolean);
        if (segments.length) {
          handle = segments[segments.length - 1];
        }
      } catch (error) {
        console.warn('[follow] failed to parse handle URL', error);
      }
    }

    handle = handle
      .split(/[?#]/, 1)[0]
      .replace(/^@+/, '')
      .replace(/\/+$/, '')
      .trim()
      .toLowerCase();

    try {
      handle = decodeURIComponent(handle);
    } catch (error) {
      console.warn('[follow] failed to decode handle', error);
    }

    return handle;
  }

  function getFollowButtons(root) {
    return Array.prototype.slice.call((root || document).querySelectorAll('.js-follow-btn'));
  }

  function getProxyBase(button) {
    return button.dataset.proxyBase || DEFAULT_PROXY_BASE;
  }

  function getFollowLabel(button) {
    return button.dataset.followLabel || '팔로우';
  }

  function getFollowingLabel(button) {
    return button.dataset.followingLabel || '팔로잉';
  }

  function getButtonDefaultHandle(button) {
    return normalizeHandle(button.dataset.followDefaultHandle || button.dataset.influencerHandle || '');
  }

  function getButtonHandle(button) {
    return normalizeHandle(button.dataset.influencerHandle || '');
  }

  function getButtonMatchHandles(button) {
    var aliases = [];
    var extraHandles = String(button.dataset.followMatchHandles || '')
      .split(',')
      .map(normalizeHandle)
      .filter(Boolean);
    var influencerName = normalizeHandle(button.dataset.influencerName || '');

    [getButtonHandle(button), getButtonDefaultHandle(button)]
      .concat(extraHandles)
      .concat(influencerName ? [influencerName] : [])
      .forEach(function (value) {
        if (value && aliases.indexOf(value) === -1) {
          aliases.push(value);
        }
      });

    return aliases;
  }

  function getReturnTo(button) {
    var fallback = window.location.pathname + window.location.search + window.location.hash;
    return String(button.dataset.returnTo || fallback || '/');
  }

  function isSameFollowTarget(button, proxyBase, handle) {
    var normalizedHandle = normalizeHandle(handle);

    return (
      getProxyBase(button) === proxyBase &&
      Boolean(normalizedHandle) &&
      getButtonMatchHandles(button).indexOf(normalizedHandle) !== -1
    );
  }

  function syncButtonTarget(button, matchedHandle, isFollowing) {
    var nextHandle = normalizeHandle(matchedHandle || '') || getButtonDefaultHandle(button);

    button.dataset.influencerHandle = nextHandle;
    button.disabled = !nextHandle;
    setButtonState(button, isFollowing);
  }

  function setButtonState(button, isFollowing) {
    button.setAttribute('aria-pressed', isFollowing ? 'true' : 'false');
    button.textContent = isFollowing ? getFollowingLabel(button) : getFollowLabel(button);
  }

  function setButtonsState(proxyBase, handle, isFollowing) {
    getFollowButtons(document).forEach(function (button) {
      if (isSameFollowTarget(button, proxyBase, handle)) {
        syncButtonTarget(button, isFollowing ? handle : '', isFollowing);
      }
    });
  }

  function setButtonsDisabled(proxyBase, handle, disabled) {
    getFollowButtons(document).forEach(function (button) {
      if (isSameFollowTarget(button, proxyBase, handle)) {
        button.disabled = disabled;
      }
    });
  }

  function parseJsonSafely(rawText) {
    if (!rawText) return null;

    try {
      return JSON.parse(rawText);
    } catch (error) {
      console.warn('[follow] non-JSON response payload', rawText);
      return null;
    }
  }

  function getFriendlyErrorMessage(message, status) {
    if (status === 404) {
      return '팔로우 앱이 아직 이 스토어에 연결되지 않았습니다. 앱 배포와 설치를 먼저 완료해 주세요. (HTTP 404)';
    }

    if (
      !message ||
      message === 'FOLLOW_REQUEST_FAILED' ||
      message === 'UNFOLLOW_REQUEST_FAILED' ||
      message === 'STATUS_REQUEST_FAILED'
    ) {
      if (status) {
        return '팔로우 처리 중 오류가 발생했습니다. (HTTP ' + status + ')';
      }

      return '팔로우 처리 중 오류가 발생했습니다.';
    }

    if (message === 'INFLUENCER_HANDLE_REQUIRED') {
      return '컬렉터 handle 값이 필요합니다.';
    }

    return message;
  }

  function isLoginRedirect(response) {
    return Boolean(
      response &&
        response.redirected &&
        (response.url.indexOf('/account/login') !== -1 || response.url.indexOf('/password') !== -1),
    );
  }

  function isHtmlResponse(response, rawText) {
    var contentType = (response && response.headers.get('content-type')) || '';

    if (contentType.indexOf('text/html') !== -1) {
      return true;
    }

    return /^\s*</.test(String(rawText || ''));
  }

  function fetchStatusSnapshot(proxyBase, handles) {
    var handleList = (handles || []).filter(Boolean);

    if (!handleList.length) {
      return Promise.resolve({ following: [], loggedIn: loginStateByProxy[proxyBase] !== false });
    }

    var searchParams = appendCustomerParams(new URLSearchParams());
    searchParams.set('handles', handleList.join(','));

    return fetch(proxyBase + '/status?' + searchParams.toString(), {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
    }).then(function (response) {
      if (!response.ok || isLoginRedirect(response)) {
        throw new Error('STATUS_REQUEST_FAILED');
      }

      return response.json();
    });
  }

  function sendMutationRequest(endpoint, payload) {
    return fetch(endpoint, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      credentials: 'same-origin',
      body: JSON.stringify(payload),
    }).then(function (response) {
      return response.text().then(function (rawText) {
        return {
          response: response,
          payload: parseJsonSafely(rawText),
          rawText: rawText,
        };
      });
    });
  }

  function syncStatuses(root) {
    var buttons = getFollowButtons(root || document);
    var groups = new Map();

    buttons.forEach(function (button) {
      var proxyBase = getProxyBase(button);
      var handle = getButtonHandle(button);

      if (!handle) {
        button.disabled = true;
        return;
      }

      if (!groups.has(proxyBase)) {
        groups.set(proxyBase, new Set());
      }

      getButtonMatchHandles(button).forEach(function (alias) {
        groups.get(proxyBase).add(alias);
      });
    });

    groups.forEach(function (handles, proxyBase) {
      var handleList = Array.from(handles);
      if (!handleList.length) return;

      fetchStatusSnapshot(proxyBase, handleList)
        .then(function (payload) {
          if (!payload || !Array.isArray(payload.following)) return;

          loginStateByProxy[proxyBase] = payload.loggedIn !== false;

          var followingSet = new Set(
            payload.following.map(function (value) {
              return normalizeHandle(value);
            }),
          );

          getFollowButtons(document).forEach(function (button) {
            var matchedHandle = getButtonMatchHandles(button).find(function (value) {
              return followingSet.has(value);
            });
            var isFollowing = Boolean(matchedHandle);

            if (!getButtonDefaultHandle(button) || getProxyBase(button) !== proxyBase) return;

            syncButtonTarget(button, matchedHandle, isFollowing);
          });
        })
        .catch(function (error) {
          console.warn('[follow] failed to sync statuses', error);
        });
    });
  }

  function handleUnauthorized() {
    if (window.self !== window.top) {
      window.alert('테마 미리보기에서는 고객 로그인 세션이 전달되지 않아 팔로우 테스트가 제한될 수 있습니다. 실제 스토어프론트 프리뷰 URL에서 고객 로그인 후 다시 확인해 주세요.');
      return;
    }

    var returnTo = window.location.pathname + window.location.search + window.location.hash;
    window.location.href = '/account/login?return_url=' + encodeURIComponent(returnTo);
  }

  function resolveLoggedInState(proxyBase, handles) {
    var handleList = Array.isArray(handles) ? handles.filter(Boolean) : [normalizeHandle(handles)];

    if (loginStateByProxy[proxyBase] != null) {
      return Promise.resolve(loginStateByProxy[proxyBase] !== false);
    }

    return fetchStatusSnapshot(proxyBase, handleList)
      .then(function (payload) {
        loginStateByProxy[proxyBase] = payload && payload.loggedIn !== false;

        if (payload && Array.isArray(payload.following)) {
          var followingSet = new Set(
            payload.following.map(function (value) {
              return normalizeHandle(value);
            }),
          );

          handleList.forEach(function (handle) {
            if (followingSet.has(handle)) {
              setButtonsState(proxyBase, handle, true);
            }
          });
        }

        return loginStateByProxy[proxyBase] !== false;
      })
      .catch(function (error) {
        console.warn('[follow] failed to resolve login state', error);
        return true;
      });
  }

  function applyMutationResult(button, proxyBase, influencerHandle, isFollowing, result) {
    var response = result.response;
    var payload = result.payload;
    var rawText = result.rawText;

    if (response.status === 401) {
      loginStateByProxy[proxyBase] = false;
      handleUnauthorized();
      return;
    }

    if ((payload && payload.message === 'LOGIN_REQUIRED') || rawText === 'LOGIN_REQUIRED' || isLoginRedirect(response)) {
      loginStateByProxy[proxyBase] = false;
      handleUnauthorized();
      return;
    }

    if (isHtmlResponse(response, rawText)) {
      throw new Error('팔로우 처리 중 오류가 발생했습니다.');
    }

    if (!response.ok || (payload && payload.ok === false)) {
      throw new Error(
        getFriendlyErrorMessage(payload && payload.message, response.status),
      );
    }

    loginStateByProxy[proxyBase] = true;

    var nextFollowing =
      payload && typeof payload.following === 'boolean'
        ? payload.following
        : !isFollowing;

    setButtonsState(proxyBase, influencerHandle, nextFollowing);
    syncStatuses(document);
    document.dispatchEvent(
      new CustomEvent('townwine:follow-change', {
        detail: {
          proxyBase: proxyBase,
          influencerHandle: influencerHandle,
          following: nextFollowing,
        },
      }),
    );
  }

  function handleFollowClick(button) {
    if (!(button instanceof HTMLButtonElement) || button.disabled) {
      return;
    }

    var proxyBase = getProxyBase(button);
    var influencerHandle = getButtonHandle(button);
    var influencerAliases = getButtonMatchHandles(button);
    var influencerName = String(button.dataset.influencerName || '').trim();

    if (!influencerHandle) {
      window.alert('먼저 컬렉터 handle 값을 설정해 주세요.');
      return;
    }

    setButtonsDisabled(proxyBase, influencerHandle, true);

    resolveLoggedInState(proxyBase, influencerAliases)
      .then(function (isLoggedIn) {
        if (!isLoggedIn) {
          handleUnauthorized();
          return null;
        }

            var isFollowing = button.getAttribute('aria-pressed') === 'true';
            var endpoint = proxyBase + (isFollowing ? '/unfollow' : '/follow');
            var customer = getCustomerContext();

            return sendMutationRequest(endpoint, {
              influencerHandle: influencerHandle,
              influencerName: influencerName,
              customerEmail: customer.email,
              customerFirstName: customer.firstName,
              returnTo: getReturnTo(button),
            }).then(function (result) {
          return {
            isFollowing: isFollowing,
            result: result,
          };
        });
      })
      .then(function (state) {
        if (!state) return;

        applyMutationResult(
          button,
          proxyBase,
          influencerHandle,
          state.isFollowing,
          state.result,
        );
      })
      .catch(function (error) {
        console.error('[follow] request failed', error);
        window.alert(
          getFriendlyErrorMessage(error && error.message),
        );
      })
      .finally(function () {
        setButtonsDisabled(proxyBase, influencerHandle, false);
      });
  }

  function bindFollowButton(button) {
    if (!(button instanceof HTMLButtonElement)) return;
    if (button.dataset.followBound === 'true') return;

    button.dataset.followBound = 'true';
    button.type = 'button';
    button.addEventListener('click', function (event) {
      if (event && event.__townwineFollowHandled) {
        return;
      }

      event.preventDefault();
      event.stopPropagation();
      handleFollowClick(button);
    });
  }

  function initializeFollowButtons(root) {
    getFollowButtons(root || document).forEach(function (button) {
      bindFollowButton(button);

      if (!getButtonHandle(button)) {
        button.disabled = true;
      }
    });

    syncStatuses(root || document);
  }

  function initialize() {
    if (!initialized) {
      initialized = true;
      document.addEventListener('shopify:section:load', function (event) {
        initializeFollowButtons(event.target);
      });
    }

    initializeFollowButtons(document);
  }

  window.TownWineFollow = {
    init: initializeFollowButtons,
    syncStatuses: syncStatuses,
    handleButtonClick: function (button, event) {
      if (event) {
        event.preventDefault();
      }

      handleFollowClick(button);
    },
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }
})();
